import { Route, Routes, useMatch } from 'react-router-dom';

import { Breadcrumb } from '../../../../components/Breadcrumb';
import { PageHeader } from '../../../../components/PageHeader';
import { PageHeading } from 'components/PageHeading';
import { AllGeneralSettingsProvider } from '../../all-settings-context';
import { IntegrationsOverview } from './Overview';
import { TelerouteSettingsPage } from '../teleroute';
import { BillitSettingsPage } from '../billit';
import { TransporeonSettingsPage } from '../transporeon';
import { TrackingSettingsPage } from '../tracking';

const INTEGRATION_NAMES: Record<string, string> = {
  teleroute: 'Teleroute',
  billit: 'Billit',
  transporeon: 'Transporeon',
  tracking: 'Tracking',
};

const IntegrationsBreadcrumb = () => {
  const match = useMatch('/internal/integrations/:slug');
  const slug = match?.params.slug;
  const childName = slug ? INTEGRATION_NAMES[slug] : undefined;

  if (!childName) {
    return <Breadcrumb currentItem="Integraties" />;
  }

  return <Breadcrumb parentItem={{ name: 'Integraties', to: '/internal/integrations' }} currentItem={childName} />;
};

const IntegrationsPage = () => {
  return (
    <>
      <PageHeader title="Integraties" />

      <PageHeading leftSide={<IntegrationsBreadcrumb />} />

      <div className="p-4">
        <AllGeneralSettingsProvider>
          <Routes>
            <Route index element={<IntegrationsOverview />} />
            <Route path="teleroute" element={<TelerouteSettingsPage />} />
            <Route path="billit" element={<BillitSettingsPage />} />
            <Route path="transporeon" element={<TransporeonSettingsPage />} />
            <Route path="tracking" element={<TrackingSettingsPage />} />
            <Route path="*" element={<p>Integratie niet gevonden</p>} />
          </Routes>
        </AllGeneralSettingsProvider>
      </div>
    </>
  );
};

export default IntegrationsPage;
